import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { environment } from '../../../environments/environment';
import { HttpService } from '../../shared/services/http.service';
import { HelperService } from '../../shared/services/helper.service';
import { SidebarService } from '../../shared/services/sidebar.service';

@Component({
  selector: 'app-raised-by-me',
  templateUrl: './raised-by-me.component.html',
  styleUrl: './raised-by-me.component.css',
})
export class RaisedByMeComponent implements OnInit {
  @Input() raiseByMeList: any = {};
  helper = inject(HelperService);
  user_Id: any;
  @Input() isDependeciesLoading: boolean = false;
  httpService = inject(HttpService);
  messageService = inject(MessageService);
  sidebarService = inject(SidebarService);
  membersLists: any = [];
  withdrawDependency: boolean = false;
  reassignDependency: boolean = false;
  selectedMember: any = null;
  searchTerm: any = '';
  selectedGroupMember: null;
  selectedGroup: any;
  groupMemberList: any;
  overAllGroupData: any;

  @Output() updateReassingState = new EventEmitter<any>();
  
  ngOnInit() {
    this.onOverAllSearchChange();
    // this.fetchMemeberLists()
  }

  fetchMemeberLists() {
    this.httpService
      .post(`${environment.opbBackendHost}/api/member/group/members`, {})
      .subscribe((res: any) => {
        this.membersLists = res?.data;
      });
  }
  onWithdraw() {
    this.withdrawDependency = true;
  }
  onReassign() {
    this.selectedMember = null;
    this.fetchMemeberLists();
    this.searchTerm = '';
    this.reassignDependency = true;
  }
  withdraw() {
    let data = {
      dependency_id: this.raiseByMeList?.dependency_id,
    };
    this.httpService
      .post(
        `${environment.opbBackendHost}/api/member/dependencies/withdrawn`,
        data
      )
      .subscribe((res: any) => {
        if (res?.code == 200) {
          this.messageService.add({
            severity: 'success',
            summary: res?.message,
          });
          this.raiseByMeList.status = 7;
        }
        // this.raiseToMeLists = res?.data;
        this.withdrawDependency = false;
      });
  }

  onOverAllSearchChange(event?: any) {
    const currentSelection: any = this.selectedGroup;

    this.httpService
      .post(`${environment.opbBackendHost}/api/member/all/groups`, {
        search: event?.filter,
      })
      .subscribe(
        (response) => {
          this.overAllGroupData = response?.data;

          if (
            currentSelection &&
            !this.overAllGroupData?.find(
              (item: any) => item?.name === currentSelection?.name
            )
          ) {
            this.overAllGroupData.push(currentSelection);
          }
        },
        (error) => {
          console.error('API Error:', error);
        }
      );
  }

  onGroupDataChange(searchTerm?: any): void {
    this.selectedGroupMember = null;
    const currentSelection: any = this.selectedGroupMember;
    const requestData = {
      groups: this.selectedGroup?.group_id,
      search: searchTerm || '',
    };
    this.httpService.post(`${environment.opbBackendHost}/api/member/group/members`, requestData).subscribe(
      (response) => {
        this.groupMemberList = response?.data;

        // Filter out logged-in user and update the list
        this.groupMemberList = this.groupMemberList.filter(
          (m: any) =>
            m?.user_id !== this.raiseByMeList.creator?.user_id &&
            m?.user_id !== this.raiseByMeList.user?.user_id
        );
        if (
          currentSelection &&
          !this.groupMemberList?.find(
            (item: any) => item?.name == currentSelection?.name
          )
        ) {
          this.groupMemberList.push(currentSelection);
        }
      },
      (error) => {
        console.error('API Error:', error);
      }
    );
  }

  onTeamSearch(event: any): void {
    this.searchTerm = event.filter;
    const url = `${environment.opbBackendHost}/api/member/group/members`;

    this.sidebarService
      .performSearch(url, { search: this.searchTerm })
      .subscribe({
        next: (data: any) => {
          this.groupMemberList = data || [];

          this.groupMemberList = this.groupMemberList.filter(
            (m: any) =>
              m?.user_id !== this.raiseByMeList.creator?.user_id &&
              m?.user_id !== this.raiseByMeList.user?.user_id
          );
        },
        error: (err: any) => {
          console.error('Error fetching data:', err);
        },
      });
  }

  onDropdownChange(event: any): void {
    this.user_Id = event?.value?.user_id;
  }

  closeWithdrawn() {
    this.withdrawDependency = false;
  }

  reassign() {
    let data = {
      dependency_id: this.raiseByMeList?.dependency_id,
      new_user_id: this.user_Id,
    };
    this.httpService
      .post(
        `${environment.opbBackendHost}/api/member/dependencies/reassign`,
        data
      )
      .subscribe((res: any) => {
        if (res?.code == 200) {
          this.messageService.add({
            severity: 'success',
            summary: res?.message,
          });
          this.updateReassingState.emit(res.data)
          this.raiseByMeList.status = 0;
          this.reassignDependency = false;
        }
      });
  }

  closeReassign() {
    this.reassignDependency = false;
  }
}
